const benSwiper = "";
document.addEventListener("DOMContentLoaded", function () {
  let benefitsSwiper = document.querySelector("[swiper='benefits']");

  if (benefitsSwiper) {
    const swiperElement = benefitsSwiper.querySelector(".swiper");

    var benSwiper = new Swiper(swiperElement, {
      speed: 300,
      slidesPerView: "auto",
      spaceBetween: 0,
      loop: false,
      centeredSlides: false,
      mousewheel: { forceToAxis: true },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      breakpoints: {
        480: { slidesPerView: "auto", spaceBetween: 0, slidesPerGroup: 1 },
        768: { slidesPerView: "auto", spaceBetween: 0, slidesPerGroup: 1 },
        992: {
          slidesPerView: 1,
          spaceBetween: 0,
          slidesPerGroup: 1,
        },
      },
      on: {
        slideChange: function () {
          updateActiveBullet(this.activeIndex);
        },
      },
    });
  }

  function initCustomBenefitBullets() {
    const bullets = document.querySelectorAll(".benefits_bullet");

    bullets.forEach((bullet, index) => {
      bullet.addEventListener("click", () => {
        bullets.forEach((b) => b.classList.remove("is--active"));

        bullet.classList.add("is--active");

        benSwiper.slideTo(index);
      });
    });
  }

  function updateActiveBullet(activeIndex) {
    const bullets = document.querySelectorAll(".benefits_bullet");
    bullets.forEach((b, index) => {
      if (index === activeIndex) {
        b.classList.add("is--active");
      } else {
        b.classList.remove("is--active");
      }
    });
  }

  initCustomBenefitBullets();
});
